import axios from "axios";
import { message } from "antd";
import { create } from "zustand";

/** BTS javobidan massivni himoyalangan tarzda ajratib oladi. */
export const pickArray = (data) => {
    if (Array.isArray(data)) return data;
    if (!data || typeof data !== "object") return [];
    return data.orders || data.items || data.list || data.data || data.results || [];
};

/** {success, data} qobig'ini ochadi. */
const unwrap = (res) => res?.data?.data ?? res?.data ?? null;

export const useBts = create((set, get) => ({
    loading: false,
    orders: [],

    // Kataloglar
    regions: [],
    cities: [],
    branches: [],
    packages: [],
    postTypes: [],
    statuses: [],

    setLoading: (v) => set({ loading: v }),

    // ---------------- Buyurtmalar ----------------
    getOrders: async (params = {}) => {
        set({ loading: true });
        try {
            const res = await axios.get("/bts/orders", { params });
            set({ orders: pickArray(unwrap(res)) });
        } catch (e) {
            message.error(e?.response?.data?.message || "Buyurtmalarni yuklab bo'lmadi");
            set({ orders: [] });
        } finally {
            set({ loading: false });
        }
    },

    getOrder: async (id) => {
        const res = await axios.get(`/bts/orders/${id}`);
        return unwrap(res);
    },

    trackOrder: async (id) => {
        const res = await axios.get(`/bts/orders/${id}/track`);
        return unwrap(res);
    },

    getSticker: async (id) => {
        const res = await axios.get(`/bts/orders/${id}/sticker`);
        return unwrap(res);
    },

    cancelOrder: async (id) => {
        const res = await axios.delete(`/bts/orders/${id}`);
        return unwrap(res);
    },

    calculate: async (payload) => {
        const res = await axios.post("/calculate", payload);
        return unwrap(res);
    },

    // ---------------- Kataloglar ----------------
    getRegions: async () => {
        try {
            const res = await axios.get("/bts/regions");
            set({ regions: pickArray(unwrap(res)) });
        } catch {
            message.warning("Viloyatlarni yuklab bo'lmadi");
        }
    },

    getCities: async (regionCode) => {
        try {
            const res = await axios.get("/bts/cities", { params: regionCode ? { region_code: regionCode } : {} });
            const list = pickArray(unwrap(res));
            set({ cities: list });
            return list;
        } catch {
            message.warning("Shaharlarni yuklab bo'lmadi");
            return [];
        }
    },

    getBranches: async (cityCode) => {
        try {
            const res = await axios.get("/bts/branches", { params: cityCode ? { city_code: cityCode } : {} });
            set({ branches: pickArray(unwrap(res)) });
        } catch {
            message.warning("Filiallarni yuklab bo'lmadi");
        }
    },

    getPackages: async () => {
        try {
            const res = await axios.get("/bts/packages");
            set({ packages: pickArray(unwrap(res)) });
        } catch {
            message.warning("Qadoq turlarini yuklab bo'lmadi");
        }
    },

    getPostTypes: async () => {
        try {
            const res = await axios.get("/bts/post-types");
            set({ postTypes: pickArray(unwrap(res)) });
        } catch {
            message.warning("Yuborish turlarini yuklab bo'lmadi");
        }
    },

    getStatuses: async () => {
        try {
            const res = await axios.get("/bts/statuses");
            set({ statuses: pickArray(unwrap(res)) });
        } catch {
            message.warning("Statuslarni yuklab bo'lmadi");
        }
    },
}));
